<template>
  <section id="single-schedule">
    <dayone />
    <daytwo />
  </section>
</template>

<script>
import dayone from '@/components/singapore25/agenda/dayone.vue';
import daytwo from '@/components/singapore25/agenda/daytwo.vue';

export default {
  name: 'Agenda Singapore',
  components: {
    dayone,
    daytwo
  },
};
</script>

<style lang="scss" scoped>
  #single-schedule {
    padding: 20px 0 60px !important;
  }
</style>